<template>
  <div>
    <ghosthouse v-if="prefix === 'GH'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <solarspace v-if="prefix === 'SOLAR'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <joker v-if="prefix === 'JOKER'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <monster v-if="prefix === 'MONSTER'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <thaidessert v-if="prefix === 'TDESSERT'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <kraken v-if="prefix === 'KRAKEN'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <vampire v-if="prefix === 'VAMPIRE'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <snowprince v-if="prefix === 'SNOWPRINCESS'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <super-bros v-if="prefix === 'SUPERBROS'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <jin-sung v-if="prefix === 'JINSUNG'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <rich-water v-if="prefix === 'RICHWATER'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <angry-bird v-if="prefix === 'ANGRYBIRD'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <doraemon v-if="prefix === 'DORAEMON'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <grand-shine v-if="prefix === 'GRANDSHRINE'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <crazy-worm v-if="prefix === 'CRAZYWORM'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <romaplus v-if="prefix === 'ROMAPLUS'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <sushi v-if="prefix === 'SUSHI35'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <peeka-boo v-if="prefix === 'PEAKABOO'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <wrath-of-egypt v-if="prefix === 'EGYPT'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <fruitNinja v-if="prefix === 'FRUITNINJA'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <kra-hung v-if="prefix === 'HUNGRYKRAHUNG'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <guardian-wizard v-if="prefix === 'GUARDIANWIZARD'" :data="resultData" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <shiba v-if="prefix === 'SHIBAMOGUL'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <shikkadood v-if="prefix === 'SHIKKADOOD'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <hoyesyellow v-if="prefix === 'HOYESYELLOW'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <blessingox v-if="prefix === 'BLESSINGOX'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <centilliongod v-if="prefix === 'CENTILLIONGOD'" :data="resultData" @fetchResult="handleFetchResult"
      :key="componentKey" :lang="$i18n.locale" />
    <moemoecute v-if="prefix === 'MOEMOECUTE'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <dinopop v-if="prefix === 'DINOPOP'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <punkstar v-if="prefix === 'PUNKSTAR'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <squidtoon v-if="prefix === 'SQUIDTOON'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <govdisco v-if="prefix === 'GOVDISCO'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <blessing-tiger v-if="prefix === 'BLESSINGTIGER'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :page="resultData.count" :isback="isBack" :key="componentKey"
      :lang="$i18n.locale" />
    <mermaid v-if="prefix === 'MERMAID'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <valentine v-if="prefix === 'CUPIDGARDEN'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <virus v-if="prefix === 'VIRUS'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <mjl v-if="prefix === 'MAHJONGLEGEND'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <Petrenger v-if="prefix === 'PETRANGER'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <veggiesbonanza v-if="prefix === 'VEGGIESBONANZA'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <Mafiaways v-if="prefix === 'MAFIAWAYS'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <LuckyNangkwak v-if="prefix === 'LUCKYNANGKWAK'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <dinogems v-if="prefix === 'DINOGEMS'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <epicofaztec v-if="prefix === 'EPICOFAZTEC'" :data="JSON.parse(JSON.stringify(resultData))" :page="resultData.count"
      :isback="isBack" @fetchResult="handleFetchResult" :key="componentKey" :lang="$i18n.locale" />
    <kingdomz v-if="prefix === 'KINGDOM'" :data="JSON.parse(JSON.stringify(resultData))" :page="resultData.count"
      :isback="isBack" @fetchResult="handleFetchResult" :key="componentKey" :lang="$i18n.locale" />
    <thaicuisine v-if="prefix === 'WCUISINE'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <fishingParadise v-if="prefix === 'FISHINGPARADISE'" :data="JSON.parse(JSON.stringify(resultData))"
      :page="resultData.count" :isback="isBack" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <alice v-if="prefix === 'ALICE'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <mahjongXmas v-if="prefix === 'MAHJONGXMAS'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <blessingDragon v-if="prefix === 'BLESSINGDRAGON'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :page="resultData.count" :isback="isBack" :key="componentKey"
      :lang="$i18n.locale" />
    <ResultPoint v-if="prefix === 'ANGPOW'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <MonkeyKing v-if="prefix === 'MONKEYKING'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <SubwayRunner v-if="prefix === 'SUBWAYRUNNER'" :data="JSON.parse(JSON.stringify(resultData))"
      :page="resultData.count" :isback="isBack" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <GuardianWealth v-if="prefix === 'GUARDIANWEALTH'" :data="JSON.parse(JSON.stringify(resultData))"
      :page="resultData.count" :isback="isBack" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <MAFIAWAYS2 v-if="prefix === 'MAFIAWAYS2'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :page="resultData.count" :isback="isBack" :key="componentKey"
      :lang="$i18n.locale" />
    <Tiki v-if="prefix === 'TIKI'" :data="JSON.parse(JSON.stringify(resultData))" @fetchResult="handleFetchResult"
      :key="componentKey" :page="resultData.count" :isback="isBack" :lang="$i18n.locale" />
    <ClashOfWars v-if="prefix === 'CLASHOFWARS'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <ResultCoin v-if="prefix === 'COIN'" :data="resultData" @fetchResult="handleFetchResult" :key="componentKey"
      :lang="$i18n.locale" />
    <NaturalAce v-if="prefix === 'NATURALACE'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <AztecLegend v-if="prefix === 'AZTECLEGEND'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <MahjongLegacy v-if="prefix === 'MAHJONGLEGACY'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <SuperAceX v-if="prefix === 'SUPERACEX'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <MahjongPhoenix v-if="prefix === 'MAHJONGPHOENIX'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <AztecEmpire v-if="prefix === 'AZTECEMPIRE'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <NekoReborn v-if="prefix === 'NEKOREBORN'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <RomaKingdom v-if="prefix === 'ROMAKINGDOM'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <Aztec1000 v-if="prefix === 'AZTEC1000'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <Olympus1000 v-if="prefix === 'OLYMPUS1000'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
    <Oneboxing v-if="prefix === 'BOXING'" :data="JSON.parse(JSON.stringify(resultData))"
      @fetchResult="handleFetchResult" :key="componentKey" :page="resultData.count" :isback="isBack"
      :lang="$i18n.locale" />
  </div>
</template>

<script>
import Ghosthouse from './resultGame/ghost'
import Solarspace from './resultGame/solarSpace'
import Joker from './resultGame/joker';
import Monster from './resultGame/monster'
import { FETCH_WINLOSE_RESULT_REQUEST } from '../store/actions/report'
import Thaidessert from './resultGame/thaiDessert';
import Kraken from './resultGame/kraken';
import Vampire from './resultGame/vampire';
import SuperBros from './resultGame/superBros';
import JinSung from './resultGame/jinSung';
import RichWater from './resultGame/richWater';
import Sushi from './resultGame/sushi.vue';
import Romaplus from './resultGame/romaplus';
import AngryBird from './resultGame/angryBird';
import GrandShine from './resultGame/grandShine';
import crazyWorm from './resultGame/crazyWorm';
import Snowprince from './resultGame/snowprinces';
import Doraemon from './resultGame/doraemon';
import PeekaBoo from './resultGame/peekaBoo';
import WrathOfEgypt from './resultGame/wrathOfEgypt';
import fruitNinja from './resultGame/fruitNinja';
import KraHung from './resultGame/kraHung';
import GuardianWizard from './resultGame/guardianWizard';
import Shiba from './resultGame/shiba'
import Shikkadood from './resultGame/shikkadood.vue';
import Hoyesyellow from './resultGame/hoyesyellow.vue';
import Blessingox from './resultGame/blessingox.vue';
import Centilliongod from './resultGame/centilliongod';
import moemoecute from './resultGame/moemoecute.vue';
import dinopop from './resultGame/dinopop.vue';
import Punkstar from './resultGame/punkstar.vue';
import Squidtoon from './resultGame/squidtoon.vue';
import Govdisco from './resultGame/govdisco.vue';
import BlessingTiger from './resultGame/blessingTiger.vue';
import Mermaid from './resultGame/mermaid.vue';
import Valentine from './resultGame/valentine.vue';
import Virus from './resultGame/virus.vue';
import Petrenger from './resultGame/petrenger.vue';
import Mjl from './resultGame/mjl.vue';
import Veggiesbonanza from './resultGame/veggiesbonanza.vue';
import Mafiaways from './resultGame/mafiaways.vue';
import LuckyNangkwak from './resultGame/luckyNangkwak.vue';
import Dinogems from './resultGame/dinogems.vue';
import Epicofaztec from './resultGame/epicofaztec.vue';
import Kingdomz from './resultGame/kingdomz.vue';
import Thaicuisine from './resultGame/thaicuisine.vue';
import FishingParadise from './resultGame/fishingParadise.vue';
import Alice from './resultGame/alice.vue';
import MahjongXmas from './resultGame/mahjongXmas.vue';
import BlessingDragon from './resultGame/blessingDragon.vue';
import ResultPoint from './resultGame/resultPoint.vue';
import MonkeyKing from './resultGame/monkeyKing.vue';
import SubwayRunner from './resultGame/subwayrunner.vue';
import GuardianWealth from './resultGame/guardianWealth.vue';
import MAFIAWAYS2 from './resultGame/mafiaways2.vue';
import Tiki from './resultGame/tiki.vue';
import ClashOfWars from './resultGame/clashofwars.vue';
import ResultCoin from './resultGame/resultCoin.vue';
import NaturalAce from './resultGame/naturalace.vue';
import AztecLegend from './resultGame/azteclegend.vue';
import MahjongLegacy from './resultGame/mahjongLegacy.vue';
import SuperAceX from './resultGame/superAceX.vue';
import MahjongPhoenix from './resultGame/mahjongPhoenix.vue';
import AztecEmpire from './resultGame/aztecempire.vue';
import NekoReborn from './resultGame/nekoReborn.vue';
import RomaKingdom from './resultGame/romaKingdom.vue';
import Aztec1000 from './resultGame/aztec1000.vue';
import Olympus1000 from './resultGame/olympus1000.vue';
import Oneboxing from './resultGame/oneboxing.vue';

export default {
  name: 'result-game',
  components: {
    Ghosthouse,
    Solarspace,
    Joker,
    Monster,
    Thaidessert,
    Kraken,
    Vampire,
    Snowprince,
    SuperBros,
    JinSung,
    RichWater,
    Sushi,
    AngryBird,
    GrandShine,
    crazyWorm,
    Doraemon,
    PeekaBoo,
    WrathOfEgypt,
    fruitNinja,
    KraHung,
    GuardianWizard,
    Shiba,
    Shikkadood,
    Hoyesyellow,
    Blessingox,
    Romaplus,
    Centilliongod,
    moemoecute,
    dinopop,
    Punkstar,
    Squidtoon,
    Govdisco,
    BlessingTiger,
    Mermaid,
    Valentine,
    Virus,
    Mjl,
    Petrenger,
    Veggiesbonanza,
    Mafiaways,
    LuckyNangkwak,
    Dinogems,
    Epicofaztec,
    Kingdomz,
    Thaicuisine,
    FishingParadise,
    Alice,
    MahjongXmas,
    BlessingDragon,
    ResultPoint,
    MonkeyKing,
    SubwayRunner,
    GuardianWealth,
    MAFIAWAYS2,
    Tiki,
    ResultCoin,
    ClashOfWars,
    NaturalAce,
    AztecLegend,
    MahjongLegacy,
    SuperAceX,
    MahjongPhoenix,
    AztecEmpire,
    NekoReborn,
    RomaKingdom,
    Aztec1000,
    Olympus1000,
    Oneboxing
  },
  data() {
    return {
      token: this.$route.query.t,
      errorModel: {
        code: 0,
        message: '',
      },
      resultHeaderModel: {
        prefix: '',
        level: '',
        room: '',
        roundId: '',
        roomId: '',
        createDate: '',
        updateDate: '',
      },
      resultData: {},
      prefix: '',
      arcadeData: {},
      gameType: '',
      componentKey: 0,
      isBack: false
    }
  },
  created() {
    this.fetchResult()
  },
  methods: {
    handleFetchResult(index, isBack) {
      this.fetchResult(index, isBack)
    },
    closeWindow() {
      window.close();
    },
    async fetchResult(data, isBack) {
      let params = {
        token: this.token,
        count: data ? data : 0
      }
      await this.$store
        .dispatch(FETCH_WINLOSE_RESULT_REQUEST, params)
        .then(res => {
          this.resultData = res
          this.prefix = res.game.prefix
          this.$i18n.locale = res.lang
          this.componentKey += 1;
          if (isBack) this.isBack = true;
        })
        .catch(err => {
          this.errorModel.code = err.code
          this.errorModel.message = err.message
        })
    },
  },
}
</script>

<style lang="css">
.error-icon {
  font-size: 4.5rem;
  color: #e66060;
}

.error-msg {
  font-size: 1.3rem;
}
</style>
